module.exports = __webpack_public_path__ + "static/media/clouds.1bc78a4c.webm";